import { Ranges } from 'api/System/types'
import type { Moment } from 'moment'
import type { State } from 'store/types'
import type { RequestDate } from 'types/UI'
import { getDateForRequest } from 'utils'

interface Action {
  dateCurrent?: Moment
  payload?: {
    range?: RequestDate
  }
}

function formatRequestDate(date?: string | null) {
  if (typeof date === 'string') return date.slice(0, 10) // YYYY-MM-DD

  return date
}

export function baseRequestParams({ datePicker }: State, action: Action = {}) {
  const { dateCurrent, dateCompared } = datePicker
  const dataCurrentForRequest = formatRequestDate(
    getDateForRequest((action.dateCurrent || (action.payload as any)?.dateCurrent) ?? (dateCurrent as any)),
  )
  const range = action.payload?.range ?? datePicker.range?.range

  return Ranges.DAY === range
    ? {
        dateCurrent: dataCurrentForRequest,
        dateCompared: formatRequestDate(getDateForRequest(dateCompared)),
      }
    : {
        dateCurrent: dataCurrentForRequest,
        range,
      }
}
